import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import api from "../../services/api";
import { store } from "react-notifications-component";
import GenericUpper from "../../components/generic-upper";

import { isTotvs, isNfAposReceita, orgaoHomologacaoNfAposReceita } from "../../services/globalFunctions";
import { getReceitaSolicitada, clearReceitaSolicitada } from "../../services/receitaSolicitada";

import PrescriptionStepOne from "../../components/prescriptionsteps/step1";
import PrescriptionStepTwo from "../../components/prescriptionsteps/step2";
import PrescriptionStepThree from "../../components/prescriptionsteps/step3";

import ModalYesNo from "../../components/modal/modalYesNo";
import ModalPassword from "../../components/modal/modal_password";
import ModalUpload from '../../components/modal/modalUploadCertificado';
import ModalAlert from '../../components/modal/modalGeneric';
import { formatDate } from "../../services/formatDate";
import { getIp } from "../../services/getIp";
import PrescriptionStepFour from "../../components/prescriptionsteps/step4";
import { DivSaldo, DivSaldoContainer } from '../receitas/styles';
import PrescriptionStepFive from "../../components/prescriptionsteps/step5";
import PrescriptionStepSix from "../../components/prescriptionsteps/step6";
import ModalAlertTotvs from "../../components/modal/modalAlertTotvs";

import { ContainerModal, ButtonPlans } from './styles';
import { TaglineP, Auxiliar, BodyG, BodyGSpan, BodyM, H5 } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';
import ModalGeneric from '../../components/modal/modalGeneric';
import ModalGenericV2 from "../../components/modal/modalGenericV2";
import InputV3 from "../../components/input/novo/input_v3";
import ButtonV2 from '../../components/button/button_v2';
import UndrawAlert from "../../assets/icons/undraw-alert.svg";

import * as S from './styles'

import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from 'recharts';
import maintainUtm from "../../services/maintainUtm";
import { getCurrentPageIdWithDevice } from "../../services/maintainUtm/idPages";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
const AddReceitas = ({ ...props }) => {

    const [title] = useState("Descobrindo o problema");
    const [subtitle, setSubtitle] = useState("");
    const [maxRelations, setMaxRelations] = useState("");
    const [align] = useState("center");
    const [userIp, setUserIp] = useState('');
    const [loadParams, setLoadParams] = useState(false);
    const [email, setEmail] = useState("");

    //step1
    const [stepOneParams, setStepOneParams] = useState([]);
    const [dataEmissao, setDataEmissao] = useState('');
    const [countRelations, setCountRelations] = useState(0);
    const [erroStepOne, setErroStepOne] = useState(false);


    //step2
    const [stepTwoParams, setStepTwoParams] = useState([]);
    const [existParamsStepTwo, setExistParamsStepTwo] = useState(false);
    const [stepTwoError, setStepTwoError] = useState(false);
    const [isOpenStepTwo, setIsOpenStepTwo] = useState(false);


    //step3
    const [stepThreeParams, setStepThreeParams] = useState([]);
    const [existParamsStepThree, setExistParamsStepThree] = useState(false);
    const [disabledStepThree, setDisabledStepThree] = useState(true);
    const [stepThreeError, setStepThreeError] = useState(false);
    const [isOpenStepThree, setIsOpenStepThree] = useState(false);

    const [senha, setSenha] = useState('');

    const [showModalYesNo, setShowModalYesNo] = useState(false);
    const [showModalPassword, setShowModalPassword] = useState(false);
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [openUpload, setOpenUpload] = useState(false);

    //step5
    const [relationsSelecionadas, setRelationsSelecionadas] = useState([]);

    const [disabledFinish, setDisabledFinish] = useState(true);

    //compendio
    const [existCompendioParams, setExistCompendioParams] = useState(false);
    const [compendioParams, setCompendioParams] = useState([]);
    const [loadingPrescription, setLoadingPrescription] = useState(false);
    const [existPassword, setExistPassword] = useState(false);
    const [sendPrescription, setSendPrescription] = useState(false);
    const [msgError, setMsgError] = useState('');

    const [iniciaVerificacao, setIniciaVerificacao] = useState(false);
    const [existEmptyValues, setExistEmptyValues] = useState(true);
    const [isApto, setIsApto] = useState(true);
    const [planoConfig, setPlanoConfig] = useState([]);
    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');
    const [saldoReceitas, setSaldoReceitas] = useState('')
    const [hasLoadedSaldoReceitas, setHasLoadedSaldoReceitas] = useState(false);
    const [produtosSelecionados, setProdutosSelecionados] = useState([]);
    const [NFeInfo, setNFeInfo] = useState('');
    const [siccaInfo, setSiccaInfo] = useState('');
    const [firstMtInfo, setFirstMtInfo] = useState({ firstPrescription: '', numberFirstArt: '' });

    const [exitDateValidation, setExitDateValidation] = useState(false);
    const [showExitValidation, setShowExitValidation] = useState(false);

    const [mounted, setMounted] = useState(false);
    const [errosNfGo, setErrosNfGo] = useState([]);

    // Inputs modal
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const [inicialDate, setInicialDate] = useState(getTodayDate());
    const [endDate, setEndDate] = useState('');
    const [priceContract, setPriceContract] = useState('');

    const [inicialDateError, setInicialDateError] = useState(false);
    const [endDateError, setEndDateError] = useState(false);
    const [priceContractError, setPriceContractError] = useState(false);

    const [loadingCreateContract, setLoadingCreateContract] = useState(false);

    // Modal Totvs
    const [showModalTotvs, setShowModalTotvs] = useState(false);
    const [showUpgradeCreditsModal, setShowUpgradeCreditsModal] = useState(false);
    const [upgradeModalDismissed, setUpgradeModalDismissed] = useState(false);
    const hasTrackedUpgradeModalView = useRef(false);

    useEffect(() => {
        if (dataEmissao) {
            setInicialDate(dataEmissao);
            setInicialDateError(false);
        }
    }, [dataEmissao]);

    useEffect(() => {
        if (localStorage.getItem("reloadEmissao") === "true") {
            localStorage.setItem("reloadEmissao", "false")
            window.location.reload()
        }
    }, [])

    const validaSaldo = async () => {
        try {
            const response = await api.get(`planos/qtd-receitas`);
            const saldoData = response.data.data.saldo_receitas;

            if (response) {
                setIsApto(true);
                setSaldoReceitas(saldoData)
            }
        } catch (error) {
            if (error.response.status === 423) {
                setIsApto(false);
            } else {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 10000,
                        onScreen: true
                    }
                });
            }
        } finally {
            setHasLoadedSaldoReceitas(true);
        }
    }

    const goHome = () => {
        setIsApto(!isApto);
        props.history.push('/');
    }

    const goToPlans = () => {
        setIsApto(!isApto);
        props.history.push('/planos');
    }

    const getIsBasicOrPrePagoPlan = () => {
        const planName = String(planoConfig?.nome_plano || '').normalize("NFD").replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();
        const isBasicPlan = planName === "PLANO BASIC";
        const isPrePagoPlan = planName === "PLANO PRE-PAGO" || planoConfig?.is_pre_pago === true || planoConfig?.agro_plan_id === 6;
        return isBasicPlan || isPrePagoPlan;
    }

    const goToPlansWithCoupon = () => {
        setShowUpgradeCreditsModal(false);
        setUpgradeModalDismissed(true);

        const currentPageId = getCurrentPageIdWithDevice();
        const search = maintainUtm(`${currentPageId}-modalupgradecreditos`);
        const searchParams = new URLSearchParams((search || '').replace('?', ''));

        searchParams.set('cupom', 'UP20');
        props.history.push(`/planos?${searchParams.toString()}`);
    }

    const closeUpgradeCreditsModal = () => {
        setShowUpgradeCreditsModal(false);
        setUpgradeModalDismissed(true);
    }

    const goToReceitas = () => {
        setIsApto(!isApto);
        const currentPageId = getCurrentPageIdWithDevice();
        const search = maintainUtm(`${currentPageId}-modalreceitascabou`);
        props.history.push(`/comprar_receitas${search}`);
    }

    const goToLimit = () => {
        setIsApto(!isApto);
        const currentPageId = getCurrentPageIdWithDevice();
        const search = maintainUtm(`${currentPageId}-modallimitemensalacabou`);
        props.history.push(`/comprar_limite${search}`);
    }

    const saveIp = async () => {
        await getIp(function (ipUser) {
            setUserIp(ipUser);
        });
    }

    const updateParamsOne = (value) => {
        setStepOneParams(value);
        if (value.relations.length > 0) {
            if (value.relations[0]) {
                if (value.relations[0].date) {
                    setDataEmissao(value.relations[0].date);
                } else if (existCompendioParams && !dataEmissao) {
                    // Clone por URL não traz data; usa hoje para liberar os próximos passos.
                    setDataEmissao(getTodayDate());
                }
            }
        }

        if (value.estado) {
            if (value.estado.value === '' && value.estado.label === '') {
                setMsgError('Selecione um estado!');
                setStepTwoParams([]);
                setStepThreeParams([]);
                setExistParamsStepTwo(false);
                setExistParamsStepThree(false);
                // setDisabledStepThree(true);
            } else {
                if (value.estado.value === '') {
                    setMsgError('Selecione um estado!');
                    // setDisabledStepThree(true);

                } else {
                    if (value.estado.value !== 'RJ') {
                        if (stepTwoParams != []) {
                            if (stepTwoParams.art && stepTwoParams.art != undefined) {
                                // setDisabledStepThree(false);
                            } else {
                                // setDisabledStepThree(true);
                            }
                        } else {
                            // setDisabledStepThree(true);
                        }
                    } else {
                        if (stepTwoParams.length !== 0) {
                            // setDisabledStepThree(false);
                        }
                    }
                }
            }
        } else {
            // setDisabledStepThree(true);
        }
        setRelationsSelecionadas(value.relations);
        setProdutosSelecionados(value.produtos);
    }

    const resetStepThree = () => {
        setStepThreeParams([]);
        setExistParamsStepThree(false);
        setStepThreeError(false);
        setIsOpenStepThree(false);
    }

    const updateParamsTwo = (value) => {
        setStepTwoParams(value);

        if (
            stepTwoParams?.art?.value &&
            stepTwoParams?.crea?.value &&
            value?.art?.value &&
            value?.crea?.value
        ) {
            const changedCrea = stepTwoParams.crea.value !== value.crea.value;

            if (changedCrea) {
                //             const changedArt = stepTwoParams.art.value !== value.art.value;
                //             const changedCrea = stepTwoParams.crea.value !== value.crea.value;

                resetStepThree();
            }
        }

        if (value?.password) {
            setSenha(value.password);
        }

        const hasResponsavel = !!value?.responsavel?.value;
        const hasCrea = !!value?.crea?.value;
        const hasAssinatura = !!value?.assinatura?.value;
        const hasArt = !!value?.art?.value;
        const estado = stepOneParams?.estado?.value;

        if (hasResponsavel || hasCrea || hasAssinatura || hasArt) {
            if (value?.erroUser) {
                // setDisabledStepThree(true);

                setExistParamsStepTwo(true);
            } else {
                setMsgError('');

                if (estado === 'RJ') {
                    if (hasResponsavel && hasCrea && hasAssinatura) {
                        // setDisabledStepThree(false);
                    }
                } else if (hasResponsavel && hasCrea && hasAssinatura && hasArt) {
                    //   setDisabledStepThree(false);
                }

                setExistParamsStepTwo(true);
            }
        } else {
            if (estado === 'SP' || estado === 'MG') {
                if (hasArt) {
                    setExistParamsStepTwo(false); // Provavelmente deveria ser true aqui?
                } else {
                    //   setDisabledStepThree(true);
                    setExistParamsStepTwo(false);
                }
            } else {
                // setDisabledStepThree(true);
                setExistParamsStepTwo(false);
            }
        }

        // ⚠️ Erros de preenchimento
        const hasErro =
            value?.erroResponsavel ||
            value?.erroCrea ||
            value?.erroAssinatura ||
            value?.erroArt;

        if (hasErro) {
            setStepTwoError(true);
        } else {
            setMsgError('');
            setStepTwoError(false);
        }
    };


    const updateIsOpenStepTwo = (isOpen) => {

        if (isOpen === true) {
            if (isOpenStepThree === true) {
                setIsOpenStepThree(false);
            }
        }
        setIsOpenStepTwo(isOpen);
    }

    const updateParamsThree = (value) => {
        if (value.produtor || value.fazenda || value.devolucao) {
            setMsgError('');
            setExistParamsStepThree(true);
            setStepThreeParams(value);
            setDisabledStepThree(false);
        }

        if (value.erroProdutor === true || value.erroFazenda === true || value.erroDevolucao === true) {
            setStepThreeError(true);
            setDisabledStepThree(true);
        } else {
            setMsgError('');
            setStepThreeError(false);
            setDisabledStepThree(false);
        }
    }

    const updateIsOpenStepThree = (isOpen) => {
        if (isOpen === true) {
            if (isOpenStepTwo === true) {
                setIsOpenStepTwo(false);
            }
        }
        setIsOpenStepThree(isOpen);
    }

    const updateQuantidadeRelations = (quantidade) => {
        setMaxRelations(quantidade);
    }

    const validatePrescription = (params) => {
        if (params) {
            if (params.stepOneParams) {

                if (params.stepOneParams.estado && params.stepOneParams.estado !== '') {
                    if (params.stepOneParams.estado.value) {
                        if (params.stepOneParams.cultura != '') {
                            if (params.stepOneParams.relations != []) {
                                if (params.stepOneParams.relations.length > 0) {

                                    if (params.stepOneParams.relations[0]) {
                                        if (erroStepOne === false) {
                                            const firstRelation = params.stepOneParams.relations[0];
                                            const hasModalidade =
                                                !!firstRelation?.modalidadeAplicacao?.value ||
                                                !!firstRelation?.modalidadeAplicacao;

                                            if (
                                                firstRelation?.areaTratar !== '' &&
                                                firstRelation?.dose !== '' &&
                                                hasModalidade &&
                                                firstRelation?.numeroAplicacoes !== '' &&
                                                firstRelation?.quantidadeAdquirir !== ''
                                            ) {
                                                if (params.dataEmissao) {
                                                    setMsgError('');
                                                    if (params.existParamsStepTwo === true && params.existParamsStepThree === true) {
                                                        if (params.stepTwoError === false && params.stepThreeError === false) {
                                                            if (params.stepTwoParams) {
                                                                if (params.stepTwoParams.erroResponsavel === false && params.stepTwoParams.erroCrea === false && params.stepTwoParams.erroArt === false) {
                                                                    if (params.stepTwoParams.responsavel.value) {
                                                                        if (params.stepTwoParams.crea.value) {
                                                                            if (params.stepTwoParams.assinatura.value) {
                                                                                if (params.stepOneParams.estado.value != 'RJ') {
                                                                                    if (params.stepTwoParams.art.value) {
                                                                                        //valida step3
                                                                                        if (params.stepThreeParams) {
                                                                                            if (params.stepThreeParams.erroProdutor === false && params.stepThreeParams.erroFazenda === false && params.stepThreeParams.erroDevolucao === false) {
                                                                                                if (params.stepThreeParams.produtor.value) {
                                                                                                    if (params.stepThreeParams.fazenda.value) {
                                                                                                        if (params.stepOneParams.estado.value === 'SP') {
                                                                                                            setDisabledFinish(false);
                                                                                                        } else if (params.stepThreeParams.devolucao.value) {
                                                                                                            if (existEmptyValues) {
                                                                                                                setDisabledFinish(true);
                                                                                                                setMsgError('Existem relações incompletas 2!');
                                                                                                            } else {
                                                                                                                setDisabledFinish(false);
                                                                                                            }
                                                                                                        } else {
                                                                                                            setDisabledFinish(true);
                                                                                                        }
                                                                                                    } else {
                                                                                                        setDisabledFinish(true);
                                                                                                    }
                                                                                                } else {
                                                                                                    setDisabledFinish(true);
                                                                                                }
                                                                                            } else {
                                                                                                setMsgError('Verifique as informações de onde o produto será aplicado!');

                                                                                                setDisabledFinish(true);
                                                                                            }
                                                                                        } else {
                                                                                            setDisabledFinish(true);
                                                                                        }
                                                                                    } else {
                                                                                        setDisabledFinish(true);
                                                                                    }
                                                                                } else {
                                                                                    // Exigir ART no RJ quando CREA.tipo === 'cfta'
                                                                                    const isCFTA = params?.stepTwoParams?.crea?.tipo === 'cfta';
                                                                                    if (isCFTA && !params?.stepTwoParams?.art?.value) {
                                                                                        setDisabledFinish(true);
                                                                                    } else {
                                                                                        if (params.stepThreeParams) {
                                                                                            if (params.stepThreeParams.erroProdutor === false && params.stepThreeParams.erroFazenda === false && params.stepThreeParams.erroDevolucao === false) {
                                                                                                if (params.stepThreeParams.produtor.value) {
                                                                                                    if (params.stepThreeParams.fazenda.value) {
                                                                                                        if (params.stepThreeParams.devolucao.value) {
                                                                                                            if (existEmptyValues) {
                                                                                                                setDisabledFinish(true);
                                                                                                                setMsgError('Existem relações incompletas 1!');
                                                                                                            } else {
                                                                                                                setDisabledFinish(false);
                                                                                                            }
                                                                                                        } else {
                                                                                                            setDisabledFinish(true);
                                                                                                        }
                                                                                                    } else {
                                                                                                        setDisabledFinish(true);
                                                                                                    }
                                                                                                } else {
                                                                                                    setDisabledFinish(true);
                                                                                                }
                                                                                            } else {
                                                                                                setDisabledFinish(true);
                                                                                            }
                                                                                        } else {
                                                                                            setDisabledFinish(true);
                                                                                        }
                                                                                    }
                                                                                }
                                                                            } else {
                                                                                setDisabledFinish(true);
                                                                            }
                                                                        } else {
                                                                            setDisabledFinish(true);
                                                                        }
                                                                    } else {
                                                                        setDisabledFinish(true);
                                                                    }
                                                                } else {
                                                                    setMsgError('Verifique as informações do responsável técnico');

                                                                    setDisabledFinish(true);
                                                                }
                                                            } else {
                                                                setDisabledFinish(true);
                                                            }
                                                        } else {
                                                            if (params.stepTwoError) {
                                                                setMsgError('Verifique as informações do responsável técnico');

                                                            }

                                                            if (params.stepThreeError) {
                                                                setMsgError('Verifique as informações de onde o produto será aplicado!');

                                                            }
                                                            setDisabledFinish(true);
                                                        }
                                                    } else {
                                                        if (params.stepTwoError) {
                                                            setMsgError('Verifique as informações do responsável técnico');

                                                        }

                                                        if (params.stepThreeError) {
                                                            setMsgError('Verifique as informações de onde o produto será aplicado!');

                                                        }
                                                        setDisabledFinish(true);
                                                    }
                                                } else {
                                                    setDisabledFinish(true);
                                                }
                                            } else {
                                                setMsgError('Verifique a prescrição do(s) produto(s)!');
                                                setDisabledFinish(true);
                                            }
                                        } else {
                                            setMsgError('Existem erros nas relações!');
                                            setDisabledFinish(true);
                                        }
                                    }
                                } else {
                                    setDisabledFinish(true);
                                }
                            } else {
                                setDisabledFinish(true);
                            }
                        } else {
                            if (params.stepOneParams.length > 0) {
                                if (params.stepOneParams.relations.length > 0) {
                                    setMsgError('Selecione uma cultura!');
                                }
                            } else if (params.stepOneParams.length === undefined) {
                                setMsgError('Selecione uma cultura!');
                            }
                            setDisabledFinish(true);
                        }
                    } else {
                        if (params.stepOneParams.length > 0) {
                            if (params.stepOneParams.relations.length > 0) {
                                setMsgError('Selecione um estado!');
                            }
                        } else if (params.stepOneParams.length === undefined) {
                            setMsgError('Selecione um estado!');
                        }
                        setDisabledFinish(true);
                    }
                } else {

                    if (params.stepOneParams.length > 0) {
                        if (params.stepOneParams.relations.length > 0) {
                            setMsgError('Selecione um estado!');
                        }
                    } else if (params.stepOneParams.length === undefined) {
                        setMsgError('Selecione um estado!');
                    }
                    setDisabledFinish(true);
                }
            } else {
                setDisabledFinish(true);
            }
        } else {
            setDisabledFinish(true);
        }
    }

    //formats
    const normalizeDecimalForPayload = (value) => {
        if (value === null || value === undefined) return '';
        const raw = String(value).trim();
        if (raw === '') return '';

        if (raw.includes('.') && raw.includes(',')) {
            return raw.replace(/\./g, '').replace(',', '.');
        }
        if (raw.includes(',')) {
            return raw.replace(',', '.');
        }
        return raw;
    };

    const formatRelationsIds = (relations) => {
        let format = [];

        relations.map((rel) => {
            format = [...format, rel.relationId];
        });

        return format;
    }
    const formatAplicationModesIds = (relations) => {
        let format = [];

        relations.map((rel) => {
            let modeId = null;
            const modalidadeAplicacao = rel?.modalidadeAplicacao;

            if (modalidadeAplicacao && typeof modalidadeAplicacao === 'object') {
                const parsed = Number(modalidadeAplicacao.value);
                modeId = Number.isFinite(parsed) ? parsed : null;
            } else if (modalidadeAplicacao !== undefined && modalidadeAplicacao !== null && modalidadeAplicacao !== '') {
                const parsed = Number(modalidadeAplicacao);
                modeId = Number.isFinite(parsed) ? parsed : null;
            }

            if (!modeId && rel?.modo_aplicacao && rel.modo_aplicacao[0]?.id) {
                const parsed = Number(rel.modo_aplicacao[0].id);
                modeId = Number.isFinite(parsed) ? parsed : null;
            }

            if (modeId) {
                format = [...format, modeId];
            }
        });

        return format;
    }
    const formatDoses = (relations) => {
        let format = [];

        relations.map((rel) => {
            format = [...format, parseFloat(rel.dose)];
        });

        return format;
    }
    const formatNumeroAplicacoes = (relations) => {
        let format = [];

        relations.map((rel) => {
            if (rel.numeroAplicacoes) {
                format = [...format, parseInt(rel.numeroAplicacoes)];
            }
        });

        return format;
    }
    const formatQuantidadeAdquirir = (relations) => {
        let format = [];

        relations.map((rel) => {
            if (rel.quantidadeAdquirir) {
                const normalized = normalizeDecimalForPayload(rel.quantidadeAdquirir);
                format = [...format, normalized];
            }
        });

        return format;
    }
    const formatUnidade = (relations) => {
        let format = [];

        relations.map((rel) => {
            if (rel.unidadeQuantidadeAdquirir) {
                format = [...format, rel.unidadeQuantidadeAdquirir];
            }
        });

        return format;
    }
    const formatArea = (relations) => {
        let format = [];

        relations.map((rel) => {
            if (rel.areaTratar) {
                const normalized = normalizeDecimalForPayload(rel.areaTratar);
                format = [...format, normalized];
            }
        });

        return format;
    }
    const formatEquipamento = (relations) => {
        let format = [];

        relations.map((rel) => {
            const eq = rel && 'equipamento' in rel ? rel.equipamento : undefined;
            if (eq === null || eq === undefined) {
                format = [...format, ""];
            } else {
                format = [...format, typeof eq === "string" ? eq : String(eq)];
            }
        });

        return format;
    }

    const formatVolume = (relations) => {
        let format = [];

        relations.map((rel) => {
            format = [...format, rel.volumeCalda];
        });

        return format;
    }

    const validaRelations = () => {
        setIniciaVerificacao(true);
    }

    const updateYesNo = async (resposta) => {
        if (resposta === 1) {
            setShowModalYesNo(false);
            validaRelations();
        } else {
            setShowModalYesNo(false);
        }
    }
    const updatePassword = (senha) => {
        setSenha(senha);
        setShowModalPassword(false);
        setExistPassword(true);
    }


    const enviarReceita = () => {
        if (getIsBasicOrPrePagoPlan() && Number(saldoReceitas) === 0) {
            setShowUpgradeCreditsModal(true);
            return;
        }
        setSendPrescription(true);
    }

    const updateYesNoDateValidate = (e) => {
        if (e === 1) {
            setExitDateValidation(true);
            setShowExitValidation(false);

            setTimeout(() => {
                enviarReceita();
            }, 300);
        } else {
            setShowExitValidation(false);
            setLoadingPrescription(false);

            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 200);
        }
    }

    const validaNFe = (nf) => {

        const parseDateFlex = (value) => {
            if (!value) return null;
            if (typeof value === 'string') {
                if (value.includes('/')) {
                    const [d, m, y] = value.split('/');
                    return new Date(`${y}-${m}-${d}T00:00:00`);
                }
                if (value.includes('-')) {
                    const [y, m, d] = value.split('-');
                    return new Date(`${y}-${m}-${d}T00:00:00`);
                }
            }
            return null;
        };

        const isNumericStr = (s) => {
            if (s === undefined || s === null) return false;
            const str = String(s).trim();
            if (str === '') return false;
            const normalized = str.replace(/\./g, ',');
            return /^\d+(,\d+)?$/.test(normalized);
        };

        const isDigitsOnly = (s) => {
            if (s === undefined || s === null) return false;
            const str = String(s).trim();
            if (str === '') return false;
            return /^\d+$/.test(str);
        };

        const safe = {
            chaveAcesso: nf && nf.chaveAcesso ? nf.chaveAcesso : '',
            razaoSocial: nf && nf.razaoSocial ? nf.razaoSocial : '',
            cpfCnpj: nf && nf.cpfCnpj ? nf.cpfCnpj : '',
            endereco: nf && nf.endereco ? nf.endereco : '',
            bairro: nf && nf.bairro ? nf.bairro : '',
            municipio: nf && nf.municipio ? nf.municipio : '',
            estado: nf && nf.estado ? nf.estado : { value: '' },
            dataEmissao: nf && nf.dataEmissao ? nf.dataEmissao : '',
            produtos: nf && Array.isArray(nf.produtos) ? nf.produtos : [],
            ncmProdutos: nf && Array.isArray(nf.ncmProdutos) ? nf.ncmProdutos : [],
            unidades: nf && Array.isArray(nf.unidades) ? nf.unidades : [],
            quantidades: nf && Array.isArray(nf.quantidades) ? nf.quantidades : []
        };

        const erros = [];

        if (!safe.chaveAcesso) { erros.push('chaveAcesso'); }
        if (!safe.razaoSocial) { erros.push('razaoSocial'); }
        if (!safe.cpfCnpj) { erros.push('cpfCnpj'); }
        if (!safe.endereco) { erros.push('endereco'); }
        if (!safe.bairro) { erros.push('bairro'); }
        if (!safe.municipio) { erros.push('municipio'); }
        if (!safe.estado.value) { erros.push('estado'); }
        if (!safe.dataEmissao) { erros.push('dataEmissao'); }

        if (safe.produtos[0] == '') { erros.push('produtos'); }
        if (!(safe.ncmProdutos.length > 0)) { erros.push('ncmProdutos'); }
        if (!(safe.unidades.length > 0)) { erros.push('unidades'); }
        if (!(safe.quantidades.length > 0)) { erros.push('quantidades'); }

        // Conteúdos inválidos
        const anyQuantidadeInvalida = safe.quantidades.some(q => !isNumericStr(q));
        if (anyQuantidadeInvalida) { if (!erros.includes('quantidades')) erros.push('quantidades'); }

        const anyNcmInvalido = safe.ncmProdutos.some(n => !isDigitsOnly(n));
        if (anyNcmInvalido) { if (!erros.includes('ncmProdutos')) erros.push('ncmProdutos'); }

        // Data NF não pode ser anterior à data da receita
        const nfDate = parseDateFlex(safe.dataEmissao);
        const receitaDate = parseDateFlex(dataEmissao);
        if (nfDate && receitaDate && nfDate < receitaDate) {
            if (!erros.includes('dataEmissao')) erros.push('dataEmissao');
        }

        setErrosNfGo(erros);

        const isValid =
            safe.chaveAcesso &&
            safe.razaoSocial &&
            safe.cpfCnpj &&
            safe.endereco &&
            safe.bairro &&
            safe.municipio &&
            safe.estado.value &&
            safe.dataEmissao &&
            safe.produtos.length > 0 &&
            safe.ncmProdutos.length > 0 &&
            safe.unidades.length > 0 &&
            safe.quantidades.length > 0 &&
            !anyQuantidadeInvalida &&
            !anyNcmInvalido &&
            !(nfDate && receitaDate && nfDate < receitaDate);

        return isValid;


    }

    const toISODate = (value) => {
        if (!value) return null;
        const str = String(value);
        if (str.includes('T')) return str.slice(0, 10);
        if (str.includes('/')) {
            const [d, m, y] = str.split('/');
            if (!y || !m || !d) return null;
            return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }
        if (str.includes('-')) {
            return str.slice(0, 10);
        }
        return null;
    };

    const emitirReceita = async (values) => {
        const hour = getUserTime();
        try {
            if (values.stepTwoParams.assinatura.value === 'D' && senha === '') {
                setShowModalPassword(true);
            } else {
                setLoadingPrescription(true);
                const agro_relation_id = formatRelationsIds(values.stepOneParams.relations);
                const agro_aplication_mode_id = formatAplicationModesIds(values.stepOneParams.relations);
                const dose = formatDoses(values.stepOneParams.relations);
                const numero_aplicacoes = formatNumeroAplicacoes(values.stepOneParams.relations);
                const quantidade_adquirir = formatQuantidadeAdquirir(values.stepOneParams.relations);
                const unidade_quantidade_adquirir = formatUnidade(values.stepOneParams.relations);
                const area_tratar = formatArea(values.stepOneParams.relations);
                const equipamento_aplicacao = formatEquipamento(values.stepOneParams.relations);
                const volume_calda = formatVolume(values.stepOneParams.relations);
                const safeNumNf = NFeInfo?.numNf !== undefined && NFeInfo?.numNf !== null ? String(NFeInfo.numNf) : '';



                const contRelations = agro_relation_id.length;

                if (
                    area_tratar.length === contRelations &&
                    dose.length === contRelations &&
                    equipamento_aplicacao.length === contRelations &&
                    numero_aplicacoes.length === contRelations &&
                    quantidade_adquirir.length === contRelations &&
                    unidade_quantidade_adquirir.length === contRelations &&
                    contRelations == countRelations
                ) {

                    let payload = {};

                    let emitir = false;

                    if (isNfAposReceita(stepOneParams.estado.value)) {
                        // const nfIncompleta =
                        //     !NFeInfo ||
                        //     !NFeInfo.chaveAcesso ||
                        //     !Array.isArray(NFeInfo.produtos) || NFeInfo.produtos.length === 0 ||
                        //     !Array.isArray(NFeInfo.ncmProdutos) || NFeInfo.ncmProdutos.length === 0 ||
                        //     !Array.isArray(NFeInfo.unidades) || NFeInfo.unidades.length === 0 ||
                        //     !Array.isArray(NFeInfo.quantidades) || NFeInfo.quantidades.length === 0;

                        // // Atualiza erros para abrir o Step 4 e pintar campos inválidos/obrigatórios
                        // validaNFe(NFeInfo);

                        // if (nfIncompleta && !exitDateValidation) {
                        //     setShowExitValidation(true);
                        //     setSendPrescription(false);
                        //     return;
                        // }

                        emitir = true

                        if (isTotvs() && dataItemRecipe) {
                            payload = {
                                order_id: dataItemRecipe.id,
                                agro_relation_id,
                                agro_aplication_mode_id,
                                dose,
                                volume_calda,
                                numero_aplicacoes,
                                quantidade_adquirir,
                                unidade_quantidade_adquirir,
                                area_tratar,
                                equipamento_aplicacao,
                                agro_crea_id: values.stepTwoParams.crea.value,
                                agro_art_id: values.stepTwoParams.art.value,
                                agro_farm_id: values.stepThreeParams.fazenda.value,
                                agro_devolution_id: values.stepThreeParams.devolucao.value,
                                assinatura: values.stepTwoParams.assinatura.value,
                                salvarAssinatura: values.stepTwoParams.salvarAssinatura,
                                senha,
                                data_emissao: dataEmissao,
                                hora_emissao: hour,
                                ip: userIp,
                                lat: lat ? lat : null,
                                lng: lng ? lng : null,
                                chave_acesso: '',
                                razao_social_emissor: '',
                                cpf_cnpj_emissor: '',
                                endereco_emissor: '',
                                bairro_emissor: '',
                                municipio_emissor: '',
                                uf_emissor: '',
                                data_emissao_nf: '',
                                nome_produto: [],
                                ncm_produto: [],
                                unidade_medida: [],
                                qtd_produto: [],
                                num_nf: '',
                                exit_date_validation: exitDateValidation,
                                sicca: siccaInfo
                            }
                        } else {
                            payload = {
                                agro_relation_id,
                                agro_aplication_mode_id,
                                dose,
                                volume_calda,
                                numero_aplicacoes,
                                quantidade_adquirir,
                                unidade_quantidade_adquirir,
                                area_tratar,
                                equipamento_aplicacao,
                                agro_crea_id: values.stepTwoParams.crea.value,
                                agro_art_id: values.stepTwoParams.art.value,
                                agro_farm_id: values.stepThreeParams.fazenda.value,
                                agro_devolution_id: values.stepThreeParams.devolucao.value,
                                assinatura: values.stepTwoParams.assinatura.value,
                                salvarAssinatura: values.stepTwoParams.salvarAssinatura,
                                senha,
                                data_emissao: dataEmissao,
                                hora_emissao: hour,
                                ip: userIp,
                                lat: lat ? lat : null,
                                lng: lng ? lng : null,
                                chave_acesso: '',
                                razao_social_emissor: '',
                                cpf_cnpj_emissor: '',
                                endereco_emissor: '',
                                bairro_emissor: '',
                                municipio_emissor: '',
                                uf_emissor: '',
                                data_emissao_nf: '',
                                nome_produto: [],
                                ncm_produto: [],
                                unidade_medida: [],
                                qtd_produto: [],
                                num_nf: '',
                                exit_date_validation: exitDateValidation,
                            }
                        }

                        // } else {
                        //     store.addNotification({
                        //         title: "Erro!",
                        //         message: `Preencha todos os campos obrigatórios da Nota Fiscal!`,
                        //         type: "danger",
                        //         insert: "top",
                        //         container: "top-right",
                        //         animationIn: ["animated", "fadeIn"],
                        //         animationOut: ["animated", "fadeOut"],
                        //         dismiss: { duration: 6000, onScreen: true }
                        //     });
                        //     setLoadingPrescription(false);
                        // }

                    } else if (stepOneParams.estado.value === 'SP') {
                        const emissaoISO = toISODate(dataEmissao);
                        const contratosArt = Array.isArray(values.stepTwoParams?.art?.contratos) ? values.stepTwoParams.art.contratos : [];
                        const farmId = values.stepThreeParams?.fazenda?.value;

                        if (emissaoISO && contratosArt.length > 0 && farmId) {
                            const contratosFarm = contratosArt.filter(c => String(c.agro_farm_id) === String(farmId));
                            const contratosAtivos = contratosFarm.filter(c => c.status === 1);
                            const pool = contratosAtivos.length > 0 ? contratosAtivos : contratosFarm;

                            const ok = pool.some(c => {
                                const ini = toISODate(c.data_inicio);
                                const fim = toISODate(c.data_termino);
                                if (!ini || !fim) return false;
                                return emissaoISO >= ini && emissaoISO <= fim;
                            });
                            if (!ok && pool.length > 0) {
                                const isoToBR = (iso) => {
                                    if (!iso) return '';
                                    const [y, m, d] = String(iso).split('-');
                                    if (!y || !m || !d) return '';
                                    return `${d}/${m}/${y}`;
                                };

                                const range = pool.reduce(
                                    (acc, c) => {
                                        const ini = toISODate(c.data_inicio);
                                        const fim = toISODate(c.data_termino);
                                        if (ini && (!acc.minIni || ini < acc.minIni)) acc.minIni = ini;
                                        if (fim && (!acc.maxFim || fim > acc.maxFim)) acc.maxFim = fim;
                                        return acc;
                                    },
                                    { minIni: null, maxFim: null }
                                );

                                const inicioBr = isoToBR(range.minIni);
                                const terminoBr = isoToBR(range.maxFim);
                                const periodoTxt = inicioBr && terminoBr ? ` (${inicioBr} a ${terminoBr})` : '';
                                store.addNotification({
                                    title: "Erro!",
                                    message: `A data de emissão da receita está fora do período do contrato dessa ART${periodoTxt}`,
                                    type: "danger",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 8000,
                                        onScreen: true
                                    }
                                });
                                setLoadingPrescription(false);
                                return;
                            }
                        }

                        const contratoExiste = await validaContratoSP(
                            values.stepTwoParams.art.value,
                            values.stepThreeParams.produtor.value,
                            values.stepThreeParams.fazenda.value
                        );

                        setArtForSearch(values.stepTwoParams.art.value);

                        if (!contratoExiste) {
                            setLoadingPrescription(false);
                            return;
                        }

                        emitir = true;
                        if (isTotvs() && dataItemRecipe) {
                        payload = {
                            order_id: dataItemRecipe.id,
                            agro_relation_id,
                            agro_aplication_mode_id,
                            dose,
                            volume_calda,
                            numero_aplicacoes,
                            quantidade_adquirir,
                            unidade_quantidade_adquirir,
                            area_tratar,
                            equipamento_aplicacao,
                            agro_crea_id: values.stepTwoParams.crea.value,
                            agro_art_id: values.stepTwoParams.art.value,
                            agro_farm_id: values.stepThreeParams.fazenda.value,
                            agro_devolution_id: values.stepThreeParams.devolucao.value || null,
                            assinatura: values.stepTwoParams.assinatura.value,
                            salvarAssinatura: values.stepTwoParams.salvarAssinatura,
                            senha,
                            data_emissao: dataEmissao,
                            hora_emissao: hour,
                            ip: userIp,
                            lat: lat ? lat : null,
                            lng: lng ? lng : null,
                            num_nf: safeNumNf,
                            exit_date_validation: exitDateValidation,
                            sicca: siccaInfo,
                            complementar_mt: firstMtInfo.firstPrescription,
                            numero_primeira_art: firstMtInfo.numberFirstArt
                            }
                        } else {
                            payload = {
                                agro_relation_id,
                                agro_aplication_mode_id,
                                dose,
                                volume_calda,
                                numero_aplicacoes,
                                quantidade_adquirir,
                                unidade_quantidade_adquirir,
                                area_tratar,
                                equipamento_aplicacao,
                                agro_crea_id: values.stepTwoParams.crea.value,
                                agro_art_id: values.stepTwoParams.art.value,
                                agro_farm_id: values.stepThreeParams.fazenda.value,
                                agro_devolution_id: values.stepThreeParams.devolucao.value || null,
                                assinatura: values.stepTwoParams.assinatura.value,
                                salvarAssinatura: values.stepTwoParams.salvarAssinatura,
                                senha,
                                data_emissao: dataEmissao,
                                hora_emissao: hour,
                                ip: userIp,
                                lat: lat ? lat : null,
                                lng: lng ? lng : null,
                                num_nf: safeNumNf,
                                exit_date_validation: exitDateValidation,
                                // sicca: siccaInfo ? siccaInfo : [],
                                complementar_mt: firstMtInfo.firstPrescription,
                                numero_primeira_art: firstMtInfo.numberFirstArt
                            }
                        }
                    } else {
                        emitir = true;
                        if (isTotvs() && dataItemRecipe) {
                        payload = {
                            order_id: dataItemRecipe.id,
                            agro_relation_id,
                            agro_aplication_mode_id,
                            dose,
                            volume_calda,
                            numero_aplicacoes,
                            quantidade_adquirir,
                            unidade_quantidade_adquirir,
                            area_tratar,
                            equipamento_aplicacao,
                            agro_crea_id: values.stepTwoParams.crea.value,
                            agro_art_id: values.stepTwoParams.art.value,
                            agro_farm_id: values.stepThreeParams.fazenda.value,
                            agro_devolution_id: values.stepThreeParams.devolucao.value,
                            assinatura: values.stepTwoParams.assinatura.value,
                            salvarAssinatura: values.stepTwoParams.salvarAssinatura,
                            senha,
                            data_emissao: dataEmissao,
                            hora_emissao: hour,
                            ip: userIp,
                            lat: lat ? lat : null,
                            lng: lng ? lng : null,
                            num_nf: safeNumNf,
                            exit_date_validation: exitDateValidation,
                            sicca: siccaInfo,
                            complementar_mt: firstMtInfo.firstPrescription,
                            numero_primeira_art: firstMtInfo.numberFirstArt
                            }
                        } else {
                            payload = {
                                agro_relation_id,
                                agro_aplication_mode_id,
                                dose,
                                volume_calda,
                                numero_aplicacoes,
                                quantidade_adquirir,
                                unidade_quantidade_adquirir,
                                area_tratar,
                                equipamento_aplicacao,
                                agro_crea_id: values.stepTwoParams.crea.value,
                                agro_art_id: values.stepTwoParams.art.value,
                                agro_farm_id: values.stepThreeParams.fazenda.value,
                                agro_devolution_id: values.stepThreeParams.devolucao.value,
                                assinatura: values.stepTwoParams.assinatura.value,
                                salvarAssinatura: values.stepTwoParams.salvarAssinatura,
                                senha,
                                data_emissao: dataEmissao,
                                hora_emissao: hour,
                                ip: userIp,
                                lat: lat ? lat : null,
                                lng: lng ? lng : null,
                                num_nf: safeNumNf,
                                exit_date_validation: exitDateValidation,
                                complementar_mt: firstMtInfo.firstPrescription,
                                numero_primeira_art: firstMtInfo.numberFirstArt
                            }
                        }
                    }

                    if (emitir) {
                        const response = await api.post(`/receitas/add`, payload);
                        const receitaId = response.data.data.id;

                        if (response) {

                            if (response.status === 206) {
                                store.addNotification({
                                    title: "Sucesso!",
                                    message: `Receita emitida com sucesso!`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                                if (response.data.message === "A receita precisa ser assinada pelo responsável técnico antes de ser enviada!") {
                                    store.addNotification({
                                        title: "Erro!",
                                        message: `${response.data.message}`,
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 10000,
                                            onScreen: true
                                        }
                                    });
                                } else {
                                    store.addNotification({
                                        title: "Erro!",
                                        message: `${response.data.message}  Aguarde alguns minutos ou entre em contato com nosso suporte!`,
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 10000,
                                            onScreen: true
                                        }
                                    });
                                    setLoadingPrescription(false);
                                }
                            } if (response.status === 426) {
                                setShowExitValidation(true);
                                setSendPrescription(false);
                            } else {
                                if (response.status === 200 && response.data.message) {
                                    store.addNotification({
                                        title: "Sucesso!",
                                        message: `${response.data.message}`,
                                        type: "success",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                } else {
                                    store.addNotification({
                                        title: "Sucesso!",
                                        message: "Receita emitida com sucesso!",
                                        type: "success",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                }
                            }

                            try {
                                localStorage.setItem('receitaEmitida', 'true');
                            } catch (e) { }
                            props.history.push('/historico');
                            const receitaPdf = response?.data?.data;
                            if (typeof receitaPdf === 'string' && receitaPdf) {
                                window.open(receitaPdf);
                            }
                        }
                    }
                } else {

                    store.addNotification({
                        title: "Erro!",
                        message: `Existem prescrições incompletas! \nRevise os produtos e emita novamente!`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 6000,
                            onScreen: true
                        }
                    });
                    setLoadingPrescription(false);
                    setTimeout(() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }, 200);
                }



                setLoadingPrescription(false);
            }
        } catch (e) {
            const errorData = e?.response?.data || {};
            const errorStatus = e?.response?.status;
            const errorMessage = errorData?.message || 'Falha ao emitir receita.';


            if (!e.response.data.errors || e.response.data.errors === undefined) {

                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(e, errorMessage),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 6000,
                        onScreen: true
                    }
                });
                setTimeout(() => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 200);
                setLoadingPrescription(false);

            } else {

                setLoadingPrescription(false);
                try {
                    const error = e.response.data.errors.agro_art_id.error;
                    store.addNotification({
                        title: "Erro!",
                        message: `${error}`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });

                } catch (err) {
                    setLoadingPrescription(false);


                    if (e.response.status === 426) {
                        setShowExitValidation(true);
                        setSendPrescription(false);
                    } else {

                        const erro = e.response.data.errors;
                        store.addNotification({
                            title: "Erro!",
                            message: identifyErrorMenssage(e, erro),
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 6000,
                                onScreen: true
                            }
                        });



                        if (e.response.status === 403) {
                            if (values.stepTwoParams.assinatura.value === 'D') {
                                setExistPassword(false);
                                setShowModalPassword(true);
                            }
                        } else if (e.response.status === 409) {
                            if (values.stepTwoParams.assinatura.value === 'D') {
                                setShowModalUpload(true);
                            }
                        }

                    }
                }
            }

        }
    }

    const setPassword = (senha) => {
        setSenha(senha);
        emitirReceita({ stepOneParams, stepTwoParams, stepThreeParams });
    }
    const closeModalPassword = () => {
        setShowModalPassword(false);
    }
    const modalUploadClose = (e) => {

        if (e === undefined) {
            setShowModalUpload(false);

            store.addNotification({
                title: "Atenção!",
                message: `Para continuar, troque o tipo de assinatura!`,
                type: "warning",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 8000,
                    onScreen: true
                }
            });

            setIsOpenStepTwo(true);

            window.scrollTo({
                top: 500,
                left: 0,
                behavior: 'smooth'
            });
        } else {
            setPassword(e);
            setShowModalUpload(false);
        }
    }
    const openModalUpload = () => {
        setShowModalPassword(false);
        setShowModalUpload(true);
    }

    const getCompendioParams = () => {

        if (window.location.search.slice(1).includes('cultures')) {
            setExistCompendioParams(true);

            // cultures=29;29&pests=722;2048&products=5;13&aplications=6;6&relations=18127;18473

            let c = [];
            let pst = [];
            let prod = [];
            let apli = [];
            let rel = [];
            let state = [];
            let d = [];
            let n = [];
            let a = [];
            let q = [];
            let query = window.location.search.slice(1);
            let partes = query.split('&');

            // 11 = URLs de clone com equipamentos; 10 = formato antigo, ainda
            // usado pelo compendio e por links ja abertos. Nao trocar por
            // igualdade estrita em 11, senao a clonagem antiga para de funcionar.
            if (partes.length === 10 || partes.length === 11) {
                let cultureSplit = partes[0].split('=');
                cultureSplit = cultureSplit[1].split(';');
                c = cultureSplit;

                let pestSplit = partes[1].split('=');
                pestSplit = pestSplit[1].split(';');
                pst = pestSplit;

                let prodSplit = partes[2].split('=');
                prodSplit = prodSplit[1].split(';');
                prod = prodSplit;

                let apliSplit = partes[3].split('=');
                apliSplit = apliSplit[1].split(';');
                apli = apliSplit;

                let relSplit = partes[4].split('=');
                relSplit = relSplit[1].split(';');
                rel = relSplit;

                let stateSplit = partes[5].split('=');
                stateSplit = stateSplit[1].split(';');
                state = stateSplit;

                let doseSplit = partes[6].split('=');
                doseSplit = doseSplit[1].split(';');
                d = doseSplit;

                let numSplit = partes[7].split('=');
                numSplit = numSplit[1].split(';');
                n = numSplit;

                let areaSplit = partes[8].split('=');
                areaSplit = areaSplit[1].split(';');
                a = areaSplit;

                let qtdSplit = partes[9].split('=');
                qtdSplit = qtdSplit[1].split(';');
                q = qtdSplit;

                let eq = [];
                if (partes[10]) {
                    const eqSplit = partes[10].split('=');
                    eq = (eqSplit[1] || '').split(';').map((valor) => {
                        try {
                            return decodeURIComponent(valor);
                        } catch (error) {
                            // Valor mal codificado nao pode derrubar a clonagem inteira.
                            return '';
                        }
                    });
                }


                let cParams = [];

                rel.map((r, i) => {
                    cParams = [...cParams, {
                        cultura: c[i] || '*',
                        praga: pst[i] || '*',
                        produto: prod[i] || '*',
                        modoAplicacao: {
                            value: apli[i] || '',
                            label: ''
                        },
                        relacaoId: rel[i] || 0,
                        estado: state[0] || '*',
                        dose: d[i] || '',
                        numApli: n[i] || '',
                        area: a[i] || '',
                        quantidade: q[i] || '',
                        equipamento: eq[i] || ''
                    }];
                })

                setCompendioParams(cParams);
                setLoadParams(true);


            } else {
                setExistCompendioParams(false);
                setLoadParams(true);
            }
        } else {
            if (window.location.search.slice(1)) {

                setExistCompendioParams(true);
                let query = window.location.search.slice(1);
                let partes = query.split('/');

                // 0 - cultura
                // 1 - praga
                // 2 - produto 
                // 3 - modo de aplicação
                // 4 - id relação

                setCompendioParams([
                    {
                        cultura: partes[0] || '*',
                        praga: partes[1] || '*',
                        produto: partes[2] || '*',
                        modoAplicacao: partes[3] || '',
                        relacaoId: partes[4] || 0,
                        estado: '*'
                    }
                ]);
                setLoadParams(true);
            } else {

                setExistCompendioParams(false);
                setLoadParams(true);
            }
        }

    }

    const updateOpenRelations = (relations) => {
    }

    const upRelationsIds = (relations) => {
        let existEmptyValue = false;

        relations.map((id) => {
            if (id === 0) {
                existEmptyValue = true;
            }
        })

        setExistEmptyValues(existEmptyValue);
    }

    const getPlanConfig = () => {
        let user = JSON.parse(localStorage.getItem('@userinfo'));

        if (user && user !== null) {
            setPlanoConfig(user.contrato.agro_plan_config);
            setEmail(user.username);
        }
    }

    const getGeolocation = () => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setLat(position.coords.latitude);
                setLng(position.coords.longitude);
            }, function (error) {
            })
        } else {
        }
    }

    const getUserTime = () => {
        var dataAtual = new Date();

        var hora = dataAtual.getHours().toString().padStart(2, '0');
        var minuto = dataAtual.getMinutes().toString().padStart(2, '0');
        var segundo = dataAtual.getSeconds().toString().padStart(2, '0');

        var horaFormatada = hora + ':' + minuto + ':' + segundo;

        return horaFormatada;
    }

    useEffect(() => {
        if (mounted === false) {
            setMounted(true);

            validaSaldo();
            saveIp();
            getCompendioParams();
            setSubtitle(<>Dúvidas na emissão da sua receita? <a href='https://www.agroreceita.com.br/como-emitir-seu-receituario-agronomico' target='_blank'> Clique aqui e acesse o tutorial. </a> </>);
            getPlanConfig();
            getGeolocation();
        }
    }, []);

    useEffect(() => {
        if (!isApto || upgradeModalDismissed || !hasLoadedSaldoReceitas) {
            return;
        }

        const isTargetPlan = getIsBasicOrPrePagoPlan();
        const availableCredits = Number(saldoReceitas);

        if (!Number.isFinite(availableCredits)) {
            return;
        }

        if (isTargetPlan && availableCredits <= 5) {
            setShowUpgradeCreditsModal(true);
        }
    }, [isApto, saldoReceitas, planoConfig, upgradeModalDismissed, hasLoadedSaldoReceitas]);

    useEffect(() => {
        if (showUpgradeCreditsModal && !hasTrackedUpgradeModalView.current) {
            hasTrackedUpgradeModalView.current = true;
        }
    }, [showUpgradeCreditsModal]);

    useEffect(() => {
        setTimeout(() => {
            setIniciaVerificacao(false);
        }, 300);
    }, [iniciaVerificacao]);

    useEffect(() => {
        if (sendPrescription === true) {
            setSendPrescription(false);
            emitirReceita({ stepOneParams, stepTwoParams, stepThreeParams });
        }
    }, [stepOneParams, stepTwoParams, stepThreeParams, sendPrescription])

    useEffect(() => {
        validatePrescription({ stepOneParams, dataEmissao, stepTwoParams, existParamsStepTwo, stepTwoError, stepThreeParams, existParamsStepThree, stepThreeError });
    }, [stepOneParams, dataEmissao, stepTwoParams, existParamsStepTwo, stepTwoError, stepThreeParams, existParamsStepThree, stepThreeError, existEmptyValues])

    useEffect(() => {
        if (existPassword === true) {
            emitirReceita({ stepOneParams, stepTwoParams, stepThreeParams });
        }
    }, [existPassword])

    useEffect(() => {
        if (stepTwoParams.length !== 0 || stepTwoParams !== undefined) {
            if (stepTwoParams.erroArt === true && stepTwoParams.erroCrea === false && stepTwoParams.erroResponsavel === false && stepTwoParams.erroUser === false) {
                setMsgError('Verifique a ART/TRT!');
            } else if (stepTwoParams.erroArt === false && stepTwoParams.erroCrea === true && stepTwoParams.erroResponsavel === false && stepTwoParams.erroUser === false) {
                setMsgError('Verifique o CREA/VISTO/CFTA!');
            } else if (stepTwoParams.erroArt === false && stepTwoParams.erroCrea === false && stepTwoParams.erroResponsavel === true && stepTwoParams.erroUser === false) {
                setMsgError('Verifique o responsável técnico!');
            } else if (stepTwoParams.erroArt === false && stepTwoParams.erroCrea === false && stepTwoParams.erroResponsavel === false && stepTwoParams.erroUser === true) {
                setMsgError('Verifique o usuário para envio da receita a defesa!');
            } else if (stepTwoParams.erroArt === true || stepTwoParams.erroCrea === true || stepTwoParams.erroResponsavel === true || stepTwoParams.erroUser === true) {
                setMsgError('Verifique as opções do responsável técnico!');
            } else {
                if (stepTwoError === true) {
                    if (!stepTwoParams.art) {
                        setMsgError('Verifique a ART/TRT!');
                    } else {
                        setMsgError('Verifique as opções do responsável técnico!');
                    }
                }
            }
        }

        if (stepThreeParams.length !== 0 || stepThreeParams !== undefined) {
            if (stepThreeError === true) {
                if (stepThreeParams.produtor === '' && stepThreeParams.fazenda !== '' && stepThreeParams.devolucao !== '') {
                    setMsgError('Verifique o produtor!');
                } else if (stepThreeParams.produtor !== '' && stepThreeParams.fazenda === '' && stepThreeParams.devolucao !== '') {
                    setMsgError('Verifique o local de aplicação!');
                } else if (stepThreeParams.produtor !== '' && stepThreeParams.fazenda !== '' && stepThreeParams.devolucao === '') {
                    setMsgError('Verifique o local de devolução!');
                } else if (stepThreeParams.produtor === '' || stepThreeParams.fazenda === '' || stepThreeParams.devolucao === '') {
                    setMsgError('Verifique as informações de onde o produto será aplicado!');

                }
            }
        }
    }, [stepOneParams, stepTwoParams, stepTwoError, stepThreeParams, stepThreeError]);


    // Modal de contratos
    const [totalContratos, setTotalContratos] = useState(0);
    const [cadastrados, setCadastrados] = useState(0);
    const [previewNumeroArt, setPreviewNumeroART] = useState('');
    const [showModalBlocked, setShowModalBlocked] = useState(false);
    const [artForSearch, setArtForSearch] = useState(0);
    const [endDateErrorInfo, setEndDateErrorInfo] = useState('');

    const notifyContratoDateError = (message) => {
        store.addNotification({
            title: "Erro!",
            message,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 6000,
                onScreen: true
            }
        });
    };

    const OnClick = async () => {
        let hasError = false;

        if (!inicialDate) {
            setInicialDateError(true);
            hasError = true;
        }

        if (!endDate) {
            setEndDateError(true);
            hasError = true;
        }

        if (!priceContract.trim()) {
            setPriceContractError(true);
            hasError = true;
        }

        const emissaoISO = toISODate(dataEmissao);
        const inicioISO = toISODate(inicialDate);
        const fimISO = toISODate(endDate);

        if (emissaoISO && inicioISO && emissaoISO < inicioISO) {
            setInicialDateError(true);
            hasError = true;
            notifyContratoDateError("A data de emissão da receita deve ser maior ou igual à data de início do contrato.");
        }

        if (emissaoISO && fimISO && emissaoISO > fimISO) {
            setEndDateError(true);
            hasError = true;
            notifyContratoDateError("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
        }

        if (hasError) return;

        setLoadingCreateContract(true);


        try {
            const payload = {
                agro_art_id: stepTwoParams.art.value,
                data_inicio: inicialDate,
                data_termino: endDate,
                valor_contrato: unformatCurrency(priceContract),
                nome_produtor: stepThreeParams.produtor.label,
                agro_farm_id: stepThreeParams.fazenda.value,
            };

            if (endDateError || !endDate) {
                return;
            }

            const response = await api.post('/contratos', payload);

            store.addNotification({
                title: "Sucesso!",
                message: "Contrato criado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });

            setShowModalBlocked(false);
            setEndDate('');
            setPriceContract('');
            props.updateAfterContrato();

        } catch (error) {
            if (error.response && error.response.status === 422) {
                const errors = error.response.data.errors;
                let errorMessage = "Erro de validação:";

                if (errors) {
                    // Se errors é um objeto com arrays de mensagens
                    if (typeof errors === 'object' && !Array.isArray(errors)) {
                        const errorMessages = [];
                        Object.keys(errors).forEach(field => {
                            if (Array.isArray(errors[field])) {
                                errorMessages.push(...errors[field]);
                            } else {
                                errorMessages.push(errors[field]);
                            }
                        });
                        errorMessage = errorMessages.join(', ');
                    }
                    // Se errors é um array de mensagens
                    else if (Array.isArray(errors)) {
                        errorMessage = errors.join(', ');
                    }
                    // Se errors é uma string
                    else if (typeof errors === 'string') {
                        errorMessage = errors;
                    }
                }

                store.addNotification({
                    title: "Erro ao salvar contrato!",
                    message: identifyErrorMenssage(error, errorMessage),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 6000,
                        onScreen: true
                    }
                });

                if (errorMessage === "Data de termino deve ser posterior a data atual.") {
                    setEndDateError(true);
                }
            }
        } finally {
            setLoadingCreateContract(false);
        }
    };

    const formatCurrency = (value) => {
        const numeric = value.replace(/\D/g, '');

        const number = parseFloat(numeric) / 100;

        if (isNaN(number)) return '';

        return number.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
        });
    };

    const unformatCurrency = (formattedValue) => {
        if (!formattedValue) return 0;
        return parseFloat(
            formattedValue
                .replace(/[R$\s]/g, '')
                .replace(/\./g, '')
                .replace(',', '.')
        );
    };

    const validaContratoSP = async (artId, produtorId, agro_farm_id) => {
        try {
            setPreviewNumeroART(stepTwoParams.art.label)
            const response = await api.get(`/contratos/${artId}/${produtorId}/${agro_farm_id}`);
            return true;
        } catch (e) {
            if (e.response?.status === 422) {
                setShowModalBlocked(true);
                return false;
            }
            throw e;
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get(`/contrato/${artForSearch}`);

                const { quantidade_contratos, contratos_cadastrados } = response.data.data;

                setTotalContratos(quantidade_contratos);
                setCadastrados(contratos_cadastrados);
            } catch (error) {
                console.error("Erro ao buscar dados de contratos:", error);
            }
        };

        if (artForSearch) fetchData(); // <- Garante que só busca se tiver ART válida
    }, [artForSearch]);


    const contratosDisponiveis = totalContratos - cadastrados;
    const percentual = totalContratos > 0 ? (cadastrados / totalContratos) * 100 : 0;

    const data = [
        {
            name: 'Contratos',
            fundo: totalContratos,
            preenchido: cadastrados,
        },
    ];

    const [dataItemRecipe, setDataItemRecipe] = useState({});
    const [dataUser, setDataUser] = useState({});
    const [modalAlertRevenueTotvs, setModalAlertRevenueTotvs] = useState(false);

    useEffect(() => {
        if (isTotvs() && dataUser.agro_permission_id !== 4) {
            const item = getReceitaSolicitada() || {};
            const user = JSON.parse(localStorage.getItem('@userinfo')) || {};
            setDataItemRecipe(item);
            setDataUser(user);
        }
    }, []);

    // useEffect(() => {
    //     console.log("dataItemRecipe", dataItemRecipe)
    // }, [dataItemRecipe]);

    //Modal Sicca MG
    const [showModalNotificationMG, setShowModalNotificationMG] = useState(false);
    const [shouldReloadEmissao, setShouldReloadEmissao] = useState(false);

    const getNotificacoesMG = async () => {
        try {
            const response = await api.get('/sicca/notificacao');

            if (response.data.status === false) {
                setShowModalNotificationMG(true);
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    useEffect(() => {
        const reloadEmissao = localStorage.getItem("reloadEmissao") === "true";
        if (reloadEmissao) {
            localStorage.setItem("reloadEmissao", "false");
        }

        (async () => {
            const openedModal = await getNotificacoesMG();
            if (reloadEmissao) {
                if (openedModal) {
                    setShouldReloadEmissao(true);
                } else {
                    window.location.reload();
                }
            }
        })();
    }, []);

    useEffect(() => {
        if (dataItemRecipe && Array.isArray(dataItemRecipe.agro_prescriptions_relations_orders)) {
            const produtosSolicitados = dataItemRecipe.agro_prescriptions_relations_orders.map(p => ({
                id: p.agro_product_id,
                nome: p.nome_comercial,
                fabricante: p.fabricante,
                quantidade: p.quantidade_adquirir,
                unidade: p.unidade_quantidade_adquirir
            }));
            // console.log('ReceitaSolicitada: produtos', produtosSolicitados);
        }
    }, [dataItemRecipe]);

    useEffect(() => {
        return () => {
            clearReceitaSolicitada();
            localStorage.removeItem('saveOptionProducerDraft');
        };
    }, []);

    return (
        <>
            <GenericUpper
                align={align}
                title={title}
                subtitle={subtitle}
                help={true}
                text={"Dúvidas na emissão da sua receita?"}
                toSearch={'https://agroreceita.com.br/como-emitir-o-receituario-agronomico/'}
                textToSearch={'Clique aqui e acesse o tutorial!'}
            ></GenericUpper>

            {saldoReceitas !== '' && getIsBasicOrPrePagoPlan() && (
                <DivSaldoContainer>
                    <DivSaldo isMobile={props.isMobile}>
                        Saldo de Receitas: {saldoReceitas}
                    </DivSaldo>
                </DivSaldoContainer>
            )}

            {loadParams ? (
                <>
                    <PrescriptionStepOne
                        updateQuantidadeRelations={(e) => updateQuantidadeRelations(e)}
                        update={(value) => updateParamsOne(value)}
                        updateErrorStepOne={(erro) => setErroStepOne(erro)}
                        updateOpenRelations={(r) => updateOpenRelations(r)}
                        updateRelationIds={(ids) => upRelationsIds(ids)}
                        isCompendio={existCompendioParams}
                        compendioParams={compendioParams}
                        countRelations={(value) => setCountRelations(value)}
                        startValidation={iniciaVerificacao}
                        enviaReceita={() => enviarReceita()}
                        maxRelations={maxRelations}
                        showIncompleteRelationAlertOnProceedOnly={true}
                        showIncompleteRelationAlertOnlyOnce={true}
                        recipeDraft={dataItemRecipe}
                    />

                    {/* RA-FRONT-2-1372: A sequencia dos steps foi alterada, o "Local de aplicação" foi trocado com o "Responsável técnico", ou seja, 
                    o stepTwo passou a ser o stepTrhee e o stepThree passou a ser o stepTwo. 
                    Não foi alterado os nomes das variaveis que tenham "stepTwo" para "stepThree" e vice-versa para não extender a tarefa/prazo.  */}

                    {/* ANTES ESSE ERA O THREE AGORA É TWO */}
                    <PrescriptionStepTwo
                        error={stepThreeError}
                        existInformation={existParamsStepThree}
                        // disabled={disabledStepThree}
                        disabled={stepOneParams.estado === undefined || dataEmissao === '' || dataEmissao === undefined ? true : false}
                        estado={stepOneParams.estado}
                        crea={stepTwoParams.crea}
                        params={stepThreeParams}
                        art={stepTwoParams.art}
                        responsavel={stepTwoParams.responsavel}
                        recipeDraft={dataItemRecipe}
                        update={(value) => updateParamsThree(value)}
                        isOpen={isOpenStepThree}
                        updateIsOpen={(isOpen) => updateIsOpenStepThree(isOpen)}
                        updateError={(erro) => setStepThreeError(erro)}
                    />

{console.log("inicialDate", inicialDate)}
                    {/* ANTES ESSE ERA O TWO AGORA É THREE*/}
                    <PrescriptionStepThree
                        id='resp'
                        error={stepTwoError}
                        existInformation={existParamsStepTwo}
                        disabled={disabledStepThree}
                        // disabled={stepOneParams.estado === undefined || dataEmissao === '' || dataEmissao === undefined ? true : false}
                        dataEmissao={dataEmissao}
                        estado={stepOneParams.estado}
                        params={stepTwoParams}
                        recipeDraft={dataItemRecipe}
                        update={(value) => updateParamsTwo(value)}
                        updateError={(erro) => setStepTwoError(erro)}
                        isOpen={isOpenStepTwo}
                        updateIsOpen={(isOpen) => updateIsOpenStepTwo(isOpen)}
                        producerData={stepThreeParams}
                        inicialDateReceita={inicialDate}
                    />

                    {/* NF enviada pela tela de histórico
                    {stepOneParams.estado !== undefined && stepOneParams.estado.value !== "MG" && !isTotvs && (
                        <PrescriptionStepFour
                            produtos={produtosSelecionados}
                            update={(nf) => setNFeInfo(nf)}
                            disabled={stepOneParams.estado ? stepOneParams.estado.value === 'GO' ? produtosSelecionados.length > 0 ? false : true : false : true}
                            estado={stepOneParams.estado ? stepOneParams.estado.value : ''}
                            erros={errosNfGo}
                    />)} */}

                    {/* <PrescriptionStepFive
                        relations={relationsSelecionadas}
                        produtos={produtosSelecionados}
                        recipeDraft={dataItemRecipe}
                        update={(nf) => setSiccaInfo(nf)}
                        disabled={stepOneParams.estado ? siccaInfo.estado === 'MG' ? produtosSelecionados.length > 0 ? false : true : false : true}
                        estado={stepOneParams.estado ? stepOneParams.estado.value : ''}
                    /> */}

                    <PrescriptionStepSix
                        update={(first) => setFirstMtInfo(first)}
                        disabled={stepOneParams.estado ? firstMtInfo.estado === 'MT' ? produtosSelecionados.length > 0 ? false : true : false : true}
                        estado={stepOneParams.estado ? stepOneParams.estado.value : ''}
                    />

                    <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px', marginBottom: '60px' }}>
                        <ButtonV2
                            width='184px'
                            height='48px'
                            value='GERAR RECEITA'
                            outline={false}
                            disabled={disabledFinish}
                            onClick={() => {
                                if (isTotvs() && Object.keys(dataItemRecipe).length === 0 && dataUser.agro_permission_id !== 4) {
                                    setModalAlertRevenueTotvs(true)
                                } else {
                                    setShowModalYesNo(true)}}
                                }
                            loading={loadingPrescription}
                            tooltip={true}
                            tooltipMsg={msgError}
                            imagePlus={true}
                        />
                    </div>

                    {showModalYesNo && (
                        <ModalYesNo
                            show={showModalYesNo}
                            onHide={() => setShowModalYesNo(false)}
                            resposta=''
                            update={(e) => updateYesNo(e)}
                            title='Atenção!'
                            text='Tem certeza que deseja finalizar? A responsabilidade pelas informações na receita agronômica é do responsável técnico. Depois de finalizada ela não poderá ser alterada!'
                        ></ModalYesNo>
                    )}

                    {showModalPassword && (
                        <ModalPassword
                            text={"Precisamos da sua senha para validar a autenticidade do certificado. Para sua segurança, essa senha não ficará salva em nossos servidores."}
                            show={showModalPassword}
                            update={(e) => updatePassword(e)}
                            onHide={() => closeModalPassword()}
                            openUpload={openUpload}
                            onHideToUpload={() => openModalUpload()}
                        />
                    )}

                    {showModalUpload && (
                        <ModalUpload
                            show={showModalUpload}
                            onHide={modalUploadClose}
                            cpf={stepTwoParams.responsavel.cpf}
                            updatePassword={(e) => setPassword(e)}
                        />
                    )}
                </>
            ) : (null)}

            <ModalAlert
                show={!isApto}
                size='lg'
                onHide={() => goHome()}
            >

                {planoConfig.agro_plan_id == 3 ? (
                    <>
                        <h4 style={{
                            width: '100%',
                            marginTop: '10px',
                            textAlign: 'center'
                        }}>
                            Seu limite de receitas mensal esgotou!
                        </h4>

                        <p style={{
                            width: '100%',
                            textAlign: 'center'
                        }}>
                            {planoConfig.is_pre_pago ? (
                                'Compre mais receitas ou atualize seu plano para continuar emitindo!'
                            ) : (
                                <>
                                    Seu saldo de <b>{planoConfig.prescriptions_limit}</b> receitas será renovado no dia <b>{formatDate(planoConfig.date_next_renewal)}</b>. Você pode aumentar seu limite de receitas mensal ou fazer um upgrade do seu plano para continuar emitindo!
                                </>
                            )}
                        </p>

                        <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: '10px', marginBottom: '10px' }}>
                            <ButtonV2
                                width='170px'
                                height='40px'
                                value='VER PLANOS'
                                outline={false}
                                disabled={false}
                                onClick={() => goToPlans()}
                                loading={false}
                                tooltip={true}
                                tooltipMsg={''}
                            />

                            <ButtonV2
                                width='170px'
                                height='40px'
                                value='AUMENTAR LIMITE'
                                outline={false}
                                disabled={false}
                                onClick={() => goToLimit()}
                                loading={false}
                                tooltip={true}
                                tooltipMsg={''}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <h4 style={{
                            width: '100%',
                            marginTop: '10px',
                            textAlign: 'center'
                        }}>
                            Seu saldo para emitir receitas acabou!
                        </h4>

                        {planoConfig.is_pre_pago ? (
                            <p style={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                                Compre mais receitas ou atualize seu plano para continuar emitindo!'
                            </p>
                        ) : (
                            <>
                                <p style={{
                                    width: '100%',
                                    textAlign: 'center'
                                }}>
                                    Precisando de mais receitas? Temos uma surpresa para te contar!
                                </p>
                                <p style={{
                                    width: '100%',
                                    textAlign: 'center'
                                }}>
                                    Assinando o AgroReceita nos próximos 14 dias você garante 10% off nas primeiras doze mensalidades.
                                </p>

                                <p style={{
                                    width: '100%',
                                    textAlign: 'center'
                                }}>
                                    Utilize o cupom <b>+RECEITAS</b> e aproveite todas as funcionalidades do AgroReceita.
                                </p>
                                <p style={{
                                    width: '100%',
                                    textAlign: 'center'
                                }}>
                                    Conheça o plano que mais se encaixa na sua necessidade.
                                </p>
                            </>
                        )}

                        <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: '10px', marginBottom: '10px' }}>
                            <ButtonV2
                                width='170px'
                                height='40px'
                                value='VER PLANOS'
                                outline={false}
                                disabled={false}
                                onClick={() => goToPlans()}
                                loading={false}
                                tooltip={true}
                                tooltipMsg={''}
                            />

                            {planoConfig.is_pre_pago ? (
                                <ButtonV2
                                    width='170px'
                                    height='40px'
                                    value='COMPRAR RECEITAS'
                                    outline={false}
                                    disabled={false}
                                    onClick={() => goToReceitas()}
                                    loading={false}
                                    tooltip={true}
                                    tooltipMsg={''}
                                />
                            ) : (null)}
                        </div>
                    </>
                )}
            </ModalAlert>

            <ModalGeneric
                show={showUpgradeCreditsModal}
                onHide={() => closeUpgradeCreditsModal()}
                marginBottom='0'
            >
                <ContainerModal>
                    <img
                        src={UndrawAlert}
                        alt="Alerta de créditos"
                        style={{ width: '11rem', display: 'block', margin: '0 auto 0.75rem auto' }}
                    />
                    <H5>{Number(saldoReceitas) === 0 ? 'Seus créditos acabaram' : 'Seus créditos estão acabando…'}</H5>

                    <BodyG color={theme.colors.darkGray2}>
                        Faça um upgrade agora mesmo e tenha créditos ilimitados. Utilize o cupom <b>UP20</b> para obter 20% de desconto nos planos Light e Pro.
                    </BodyG>

                    <ButtonPlans>
                        <ButtonV2
                            width='170px'
                            height='40px'
                            value='VER PLANOS'
                            outline={false}
                            disabled={false}
                            onClick={() => goToPlansWithCoupon()}
                            loading={false}
                            tooltip={false}
                            tooltipMsg=''
                        />
                    </ButtonPlans>
                </ContainerModal>
            </ModalGeneric>

            {showExitValidation && (
                <ModalYesNo
                    show={showExitValidation}
                    btnNo={true}
                    onHide={() => setShowExitValidation(false)}
                    resposta=''
                    update={(e) => updateYesNoDateValidate(e)}
                    title='Atenção!'
                    text='Já foram emitidas receitas para essa ART com data posterior a data de emissão informada! Deseja emitir a receita mesmo assim? O controle do número de ART/TRT pode ser comprometido!'
                ></ModalYesNo>
            )}

            <ModalGeneric
                show={showModalBlocked}
                onHide={() => setShowModalBlocked(false)}
                marginBottom='0'
            >

                <ContainerModal>
                    <H5>Criar novo Contrato</H5>

                    <BodyM color='#303848'>
                        O Produtor selecionado não possui Contrato ativo na ART/TRT selecionada. Preencha os campos abaixo para criar um Contrato:
                    </BodyM>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', marginTop: '1.5rem', marginBottom: '0.25rem' }}>

                        <InputV3
                            id="datetime"
                            type="date"
                            label="Selecione Data inicial do Contrato"
                            floatingLabelWithAsterisk="Data inicial do Contrato"
                            value={inicialDate}
                            onChange={(e) => {
                                const value = e.target.value;
                                setInicialDate(value);

                                if (!value) {
                                    setInicialDateError(true);
                                    return;
                                }

                                const emissaoISO = toISODate(dataEmissao);
                                const inicioISO = toISODate(value);

                                if (emissaoISO && inicioISO && emissaoISO < inicioISO) {
                                    setInicialDateError(true);
                                    notifyContratoDateError("A data de emissão da receita deve ser maior ou igual à data de início do contrato.");
                                } else {
                                    setInicialDateError(false);
                                }

                                if (endDate) {
                                    const fimISO = toISODate(endDate);
                                    if (emissaoISO && fimISO && emissaoISO > fimISO) {
                                        setEndDateError(true);
                                        setEndDateErrorInfo("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
                                        notifyContratoDateError("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
                                    }
                                }
                            }}
                            disabled={false}
                            hasError={inicialDateError}
                        />

                        <InputV3
                            id="datetime"
                            type="date"
                            label="Selecione Data final do Contrato (prevista)"
                            floatingLabelWithAsterisk="Data final do Contrato"
                            value={endDate}
                            onChange={(e) => {
                                const value = e.target.value;
                                setEndDate(value);

                                const hoje = new Date();
                                const final = new Date(value);
                                const inicio = new Date(inicialDate);
                                const emissaoISO = toISODate(dataEmissao);
                                const fimISO = toISODate(value);

                                if (!value) {
                                    setEndDateError(true);
                                    setEndDateErrorInfo('Preencha a data final.');
                                } else if (final < inicio) {
                                    setEndDateError(true);
                                    setEndDateErrorInfo('A data final não pode ser menor que a data inicial.');
                                    notifyContratoDateError('A data final do contrato não pode ser menor que a data inicial do contrato.');
                                } else if (inicialDate && final < inicio) {
                                    setEndDateError(true);
                                    setEndDateErrorInfo('A data final não pode ser menor que a data inicial.');
                                    notifyContratoDateError('A data final do contrato não pode ser menor que a data inicial do contrato.');
                                } else if (emissaoISO && fimISO && emissaoISO > fimISO) {
                                    setEndDateError(true);
                                    setEndDateErrorInfo("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
                                    notifyContratoDateError("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
                                } else {
                                    setEndDateError(false);
                                    setEndDateErrorInfo('');
                                }
                            }}
                            hasError={endDateError}
                        />

                        <InputV3
                            type="text"
                            floatingLabelWithAsterisk="Valor estimado do Contrato (R$)"
                            value={priceContract}
                            onChange={(e) => {
                                const formatted = formatCurrency(e.target.value);
                                setPriceContract(formatted);
                                if (formatted.trim()) setPriceContractError(false);
                            }}
                            onKeyDown={(e) => {
                                const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                const isNumber = /^[0-9]$/.test(e.key);

                                if (!isNumber && !allowedKeys.includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            hasError={priceContractError}
                        />

                    </div>

                    <div>
                        {totalContratos > 0 && (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                <div style={{ maxWidth: '160px', width: '100%' }}>
                                    <BarChart
                                        width={160}
                                        height={6}
                                        data={data}
                                        layout="vertical"
                                        barSize={4}
                                        style={{ borderRadius: '20px' }}
                                    >
                                        <XAxis type="number" hide domain={[0, totalContratos]} />
                                        <YAxis type="category" dataKey="name" hide />
                                        <Bar dataKey="preenchido" stackId="a" radius={[20, 20, 20, 20]}>
                                            <Cell fill={theme.colors.green.Verde_AgroReceita} />
                                        </Bar>

                                        <Bar dataKey="fundo" stackId="a" radius={[20, 20, 20, 20]}>
                                            <Cell fill={theme.colors.disabled.Fundo_Desabilitado} />
                                        </Bar>

                                    </BarChart>
                                </div>

                                <Auxiliar fontWeight="700" style={{ marginTop: '1rem' }}>
                                    {contratosDisponiveis} Contratos disponíveis de {totalContratos}
                                </Auxiliar>
                            </div>
                        )}

                        <Auxiliar fontWeight='400' color="#586377">ART: {previewNumeroArt}</Auxiliar>
                    </div>

                    <ButtonPlans>
                        <ButtonV2
                            width='100%'
                            height='60px'
                            value='Criar Novo Contrato'
                            outline={false}
                            disabled={loadingCreateContract}
                            onClick={OnClick}
                            loading={loadingCreateContract}
                        />
                    </ButtonPlans>
                </ContainerModal>
            </ModalGeneric>

            {showExitValidation && (
                <ModalYesNo
                    show={showExitValidation}
                    btnNo={true}
                    onHide={() => (setShowExitValidation(false), setLoadingPrescription(false))}
                    resposta=""
                    update={(e) => updateYesNoDateValidate(e)}
                    title="Atenção!"
                    state={stepOneParams.estado.value}
                    type='nfe'
                    text={`Os dados da Nota Fiscal não foram informados neste momento, pois dependem do número da receita. Você poderá completar essas informações em até 7 dias, conforme exigência do ${orgaoHomologacaoNfAposReceita(stepOneParams.estado.value)}.`}
                />
            )}

            <ModalAlert
                width="500px"
                show={showModalNotificationMG}
                onHide={() => {
                    setShowModalNotificationMG(false);
                    if (shouldReloadEmissao) {
                        window.location.reload();
                    }
                }}
            >
                <h4 style={{ textAlign: "center" }}>Aviso:</h4>

                <p
                    style={{
                        textAlign: "center",
                        marginTop: "20px",
                    }}
                >
                    A partir de agora, o AgroReceita permitirá a geração do relatório de comercialização para o SICCA MG com as informações da NF, conforme a <a href="https://www.nfe.fazenda.gov.br/portal/exibirArquivo.aspx?conteudo=7fsG1qp0vrU= ">Nota Técnica 2024.003</a>.
                    <br />
                    Os receituários agronômicos devem ser emitidos antes da nota fiscal e, somente após isso, você poderá preencher os dados da NF no sistema.
                </p>

                <div
                    className="button-finish"
                    style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        marginTop: "40px",
                    }}
                >
                    <ButtonV2
                        width="296px"
                        height="50px"
                        value="ENTENDI"
                        outline={false}
                        disabled={false}
                        onClick={() => {
                            setShowModalNotificationMG(false);
                            if (shouldReloadEmissao) {
                                window.location.reload();
                            }
                        }}
                        loading={false}
                    />
                </div>
            </ModalAlert>

             <ModalAlertTotvs 
                show={showModalTotvs}
                marginBottom="0"
                onHide={() => setShowModalTotvs(false)}
                />

            {modalAlertRevenueTotvs && (
                <ModalGenericV2 
                    show={modalAlertRevenueTotvs} 
                    onHide={() => setModalAlertRevenueTotvs(false)}
                    marginBottom="0"
                    >
                    <S.ContainerModalAlertRevenueTotvs>
                        <H5 color={theme.colors.gray.Cinza_2}>
                            Receita Avulsa!
                        </H5>

                        <BodyG color={theme.colors.gray.Cinza_2}>
                            Você está emitindo uma receita avulsa, portanto a receita emitida não será vinculada ao PROTHEUS. <br/>
                            A responsabilidade pelas informações na receita agronômica é do responsável técnico. <br/>
                            Depois de finalizada ela não poderá ser alterada! <br/>
                            Tem certeza que deseja finalizar?
                        </BodyG>
        
                        <div style={{width: '100%', height: 'auto', gap: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <ButtonV2
                                width='100px'
                                height='40px'
                                value="Cancelar"
                                outline={false}
                                disabled={false}
                                onClick={() => setModalAlertRevenueTotvs(false)}
                                loading={false}
                                red={true}
                            />
                            
                            <ButtonV2
                                width='140px'
                                height='40px'
                                value="EMITIR RECEITA AVULSA"
                                outline={false}
                                disabled={false}
                                onClick={() => {
                                    setModalAlertRevenueTotvs(false)
                                    validaRelations(); 
                                }}
                                loading={false}
                            />
                        </div>
                    </S.ContainerModalAlertRevenueTotvs>
                </ModalGenericV2>
            )}
        </>
    );
};

export default withRouter(AddReceitas);
